import rolesSelectors from 'modules/Roles/selectors'
import { connect } from 'react-redux'
import Dashboardindex from '../../ViewRole/Header/QuestionaireDashboard/index'

import {
  createShortList,
  getAppliedCandidateList,
  getAppliedCandidateListTrue,
  getCandidateDetails,
  getCollegeBasedOnQuestionnier,
  getDegreeBasedOnQuestionnier,
  getDegreesBasedOnRoles,
  getInstitutesList,
  getPromotion,
  getQuestionnaireDetails,
  getRoleViewCard,
  getRoleViewChart,
  getSingleRoleData,
  getStudentQuestionaireList,
  jobSharingEmail,
  setInstitutesList,
} from 'modules/Roles/actions'
import {
  getIndividualDrawerList,
  getQuestionAndAnswerList,
  getQuestionaireGraphList,
} from '../../ViewRole/Header/QuestionaireDashboard/actions'

const mapStateToProps = state => ({
  roleViewCardData: rolesSelectors.getRoleViewCard(state),
  roleViewChartData: rolesSelectors.getRoleViewChart(state),
  roleBasedDegreeList: rolesSelectors?.getDegreeRolesList(state),
  singleRoleData: rolesSelectors?.getSingleRoleData(state),
  qbBasedCollegeList: rolesSelectors?.getCollegeQBList(state),
  qbsBasedDegreeList: rolesSelectors?.getDegreeQBList(state),
  appliedCandidatesList: rolesSelectors?.getAppliedCandidatesList(state),
  appliedCandidatesListTrue:
    rolesSelectors?.getAppliedCandidatesListTrue(state),
  candidateDetails: rolesSelectors.getCandidateDetails(state),
  institutesList: rolesSelectors.getInstitutesList(state),
  individualDrawerQuestion: rolesSelectors.getIndividualDrawerData(state),
  graphList: rolesSelectors.graphListData(state),
  questionaireDBList: rolesSelectors.getStudentQuestionaireList(state),
  questionnaireData: rolesSelectors.getQuestionnaireDetails(state),
  promotionData: rolesSelectors.getPromotion(state),
})

const mapDispatchToProps = {
  getRoleViewChart,
  getRoleViewCard,
  getDegreesBasedOnRoles,
  getSingleRoleData,
  getAppliedCandidateList,
  getAppliedCandidateListTrue,
  getCandidateDetails,
  getInstitutesList,
  setInstitutesList,
  createShortList,
  jobSharingEmail,
  getIndividualDrawerList,
  getPromotion,
  getStudentQuestionaireList,
  getQuestionnaireDetails,
  getQuestionaireGraphList,
  getCollegeBasedOnQuestionnier,
  getDegreeBasedOnQuestionnier,
  getQuestionAndAnswerList,
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboardindex)
